import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { api, fmtDate, fmtDateTime, fmtMoney } from "@/lib/api";
import { RENTAL_FIELDS } from "@/lib/forms";

const S1 = ["customer_id", "driver_id", "second_driver_id"];
const S2 = ["vehicle_id", "planned_start", "planned_end", "actual_start", "actual_end"];
export const RENTAL_STEPS = [
  { title: "Cliente e conducenti", names: S1 }, { title: "Veicolo e date", names: S2 },
  { title: "Luoghi, prezzi e altri dati", names: RENTAL_FIELDS.map((f) => f.name).filter((n) => !S1.includes(n) && !S2.includes(n)) },
  { title: "Riepilogo", names: [] },
];
const ROLES = [["customer_id", "Cliente"], ["driver_id", "Conducente"], ["second_driver_id", "Secondo conducente"]];
const DOCS = [["doc_expiry", "documento d'identità"], ["license_expiry", "patente"]];
const fullName = (c) => [c?.last_name, c?.first_name].filter(Boolean).join(" ") || c?.company_name || "—";

function usePeople(form) {
  const [map, setMap] = useState({});
  const ids = ROLES.map(([k]) => form[k]).filter(Boolean);
  useEffect(() => {
    ids.filter((id) => !map[id]).forEach((id) => api.get(`/customers/${id}`).then((r) => setMap((m) => ({ ...m, [id]: r.data }))).catch(() => {}));
  }, [ids.join(",")]); // eslint-disable-line react-hooks/exhaustive-deps
  return map;
}

export function docWarnings(form, map) {
  const ref = (form.planned_start || new Date().toISOString()).slice(0, 10);
  const out = [];
  ROLES.forEach(([k, role]) => {
    const c = map[form[k]];
    if (!c || (k === "driver_id" && form.driver_id === form.customer_id)) return;
    DOCS.forEach(([f, l]) => { if (c[f] && c[f].slice(0, 10) < ref) out.push(`${role} ${fullName(c)}: ${l} scaduto il ${fmtDate(c[f])} (ritiro ${fmtDate(ref)})`); });
  });
  return out;
}

function Warnings({ list }) {
  if (!list.length) return null;
  return <div className="rounded-md border border-red-500/40 bg-red-500/10 p-3 text-sm text-red-300 space-y-1" data-testid="rental-doc-warnings">
    {list.map((w) => <div key={w} className="flex gap-2"><AlertTriangle size={15} className="shrink-0 mt-0.5" />{w}</div>)}</div>;
}

function Summary({ form, map }) {
  const rows = [["Cliente", fullName(map[form.customer_id])], ["Conducente", form.driver_id ? fullName(map[form.driver_id]) : "—"],
    ["Secondo conducente", form.second_driver_id ? fullName(map[form.second_driver_id]) : "—"],
    ["Ritiro previsto", fmtDateTime(form.planned_start)], ["Riconsegna prevista", fmtDateTime(form.planned_end)],
    ["Prezzo", form.price != null ? fmtMoney(form.price) : "—"], ["Cauzione", form.deposit != null ? fmtMoney(form.deposit) : "—"], ["Stato", form.status || "—"]];
  return <div className="grid sm:grid-cols-2 gap-x-6 gap-y-2 text-sm" data-testid="rental-summary">
    {rows.map(([l, v]) => <div key={l}><div className="text-xs text-zinc-500">{l}</div><div>{v}</div></div>)}</div>;
}

export function RentalStepTop({ form, setForm, step }) {
  const map = usePeople(form);
  const same = !!form.driver_same;
  useEffect(() => { if (same && form.driver_id !== form.customer_id) setForm((s) => ({ ...s, driver_id: s.customer_id || null })); }, [same, form.customer_id]); // eslint-disable-line react-hooks/exhaustive-deps
  const warns = docWarnings(form, map);
  return <div className="space-y-3">
    {step === 0 && <label className="flex items-center gap-2 text-sm" data-testid="driver-same-label">
      <input type="checkbox" checked={same} onChange={(e) => setForm((s) => ({ ...s, driver_same: e.target.checked, driver_id: e.target.checked ? s.customer_id || null : s.driver_id }))} data-testid="driver-same-checkbox" />
      Il conducente è il cliente</label>}
    {(step === 0 || step === 1 || step === 3) && <Warnings list={warns} />}
    {step === 3 && <Summary form={form} map={map} />}
  </div>;
}
